<template>
	<div class="wrapBox">
		<navheader current="4"></navheader>
		<div class="bannerBox">
			<div class="bannerCtx">
				<div class="banner-img-container">
					<img  src="../assets/images/banner1.png" class="imgsize" />
				</div>
			</div>
		</div>
		<!-- <div class="news-list">
			<div class="news-item" v-for="(item, index) in itemlist" :key="index">
				<div class="news-img">
					<img :src="item.imagePath1 || require('../assets/images/default-news.png')" alt="新闻图片" />
				</div>
				<div class="news-content">
					<div class="news-title">{{ item.title }}</div>
					<div class="news-desc" v-html="item.memo"></div>
					<div class="news-date">{{ item.createTime }}</div>
				</div>
			</div>
		</div> -->
		<footercommon></footercommon>
	</div>
</template>

<script>
	import navheader from '../components/navheader.vue'
	import footercommon from '../components/footercommon.vue'
	import bannerswipt from "../components/bannerswipt.vue";
	import {GetTalentRecruitment} from '@/api/api'
	export default{
		components:{navheader,footercommon,bannerswipt},
		data(){
			return{
				leftTitle:'新闻动态',
				current:this.$route.query.current||0,
				list:['新闻咨询','协华公告','媒体视点'],
				itemlist:[],
				
				conpages:'',//总页数
				cur:1, //当前页
				pageSize:5, //每页要展示数据条数
			}
		},
		mounted() {
			
		},
		methods:{
		}
	}
</script>

<style lang="scss" scoped>
	.banner-img-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
}

.imgsize{
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}

.contentbox{
		// min-width: $commoneWidth;
		margin: 9.375rem;
		color:#3B5B59;
		line-height: 2rem;
		font-size: 1.375rem;
		text-align: justify;
		.contentItem{
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 10.625rem;
			.textbox{
				width: calc(100% - 35rem);
				.title{
					color:$baseColor;
					font-size: 2.625rem;
					font-weight: 800;
				}
				.ctx{
					margin-top: 2.3125rem;
					font-weight: 600;
				}
			}
		}
	}
	.fixed-footer {
		position: fixed;
		bottom: 0;
		width: 100%;
	}
	@media screen and (min-width: 769px) {//pc版本
		.smallBox{
			display: none;
		}
	}
	@media screen and (max-width: 768px) {//手机版本
		.bannerBox .bannerCtx{
			height: 9.8125rem;
		}
		.commonBox{
			display: none;
		}
		.imgsize{
			width: 100%;
			height: 157px;
		}
		.contentbox{
			width:100%;
			margin: 0 auto;
			font-size: 12px;
			min-height: 345px;
			color:#3B5B59;
			line-height: 20px;
			padding: 10px;
			box-sizing: border-box;
			.img {
				width: 375px!important;
				height: 157px !important;
			}
		}
	}
</style>
 